import { useForm } from "react-hook-form";
import FormTextField, {
  emailValidationPattern,
  passwordValidationPattern,
} from "../components/formComponents/FormTextField";
import AsyncLoadingButton from "../components/asyncLoadingButton/AsyncLoadingButton";
import SignInSignUpSwitch from "./SignInSignUpSwitch";
import { auth } from "../auth/auth";
import { useSnackbar } from "notistack";
import { isErrorWithMessage } from "../misc/isErrorWithMessage";
import { useNavigate } from "react-router-dom";
import { logSignUpEvent } from "../misc/firebase";

interface EmailPasswordLoginFormState {
  readonly email: string;
  readonly password: string;
  readonly confirmPassword: string;
}

const EmailPasswordSignUp = () => {
  const { control, handleSubmit } = useForm<EmailPasswordLoginFormState>({
    defaultValues: { email: "", password: "", confirmPassword: "" },
  });
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const enqueueSignUpError = (reason: string, message = "Rejestracja nie powiodła się") =>
    enqueueSnackbar({
      variant: "error",
      message: `${message}. Powód: ${reason}`,
      autoHideDuration: 15000,
    });

  const onSubmit = async (email: string, password: string) => {
    try {
      await auth.signUpWithEmailAndPassword(email, password);
      enqueueSnackbar(`Konto zostało dla adresu ${email} zostało utworzone. Możesz się zalogować.`, {
        variant: "success",
      });
      logSignUpEvent("email_and_password");
      navigate("/login");
    } catch (error) {
      enqueueSignUpError(isErrorWithMessage(error) ? error.message : JSON.stringify(error));
    }
  };

  return (
    <SignInSignUpSwitch minWidth="550px">
      <FormTextField
        type="email"
        name="email"
        label="Email"
        control={control}
        rules={{ required: true, pattern: emailValidationPattern }}
      />
      <FormTextField
        type="password"
        name="password"
        label="Hasło"
        control={control}
        rules={{ required: true, pattern: passwordValidationPattern }}
      />
      <FormTextField
        type="password"
        name="confirmPassword"
        label="Powtórz hasło"
        control={control}
        rules={{
          required: true,
          pattern: passwordValidationPattern,
          validate: (value, formValues) => (value === formValues.password ? undefined : "Hasła muszą być takie same"),
        }}
      />
      <AsyncLoadingButton onClick={handleSubmit((s) => onSubmit(s.email, s.password))}>
        Zarejestruj się
      </AsyncLoadingButton>
    </SignInSignUpSwitch>
  );
};

export default EmailPasswordSignUp;
